import { ASSIGNMENT_TYPE } from "@/modules/lead-page/dtos/index-v2";
import ActivityDetailsText from "@/modules/lead-page/new/components/activity/activity-details-typography";
import UserNameTag from "@/modules/lead-page/new/components/activity/user-name-tag";
import { Stack, useTheme } from "@mui/material";

interface AssignmentDetailsProps {
  actorName?: string | null;
  actorColor?: string | null;
  previousUserName?: string | null;
  previousUserColor?: string | null;
  newUserName?: string | null;
  newUserColor?: string | null;
  assignmentType?: ASSIGNMENT_TYPE | null;
  entityType?: string;
}

const assignmentTypeToTextMap = new Map([
  [ASSIGNMENT_TYPE.MANUAL, "manually"],
  [ASSIGNMENT_TYPE.MANUAL_MULTI_SELECTION, "using manual multi-selection"],
  [ASSIGNMENT_TYPE.WITH_MANUAL_MULTI_SELECTION, "using manual multi-selection"],
  [ASSIGNMENT_TYPE.AUTO_ASSIGNMENT, "using auto assignment"],
  [ASSIGNMENT_TYPE.AUTO_ASSIGNMENT_BUTTON, "using auto assignment"],
  [
    ASSIGNMENT_TYPE.AUTOMATIC_AUTO_ASSIGNMENT,
    "Automatically due to Auto Assignment trigger",
  ],
  [
    ASSIGNMENT_TYPE.BOT_AUTOASSIGNMENT,
    "Automatically due to Bot Auto Assignment trigger",
  ],
  [ASSIGNMENT_TYPE.REASSIGN_TO_MANAGER, "using re-assign to manager"],
  [ASSIGNMENT_TYPE.SINGLE_LEAD, "through add lead"],
  [ASSIGNMENT_TYPE.ROTATION, "using rotation"],
  [ASSIGNMENT_TYPE.POOL, ""],
  [ASSIGNMENT_TYPE.FROM_POOL, "from pool"],
  [ASSIGNMENT_TYPE.DELEGATION, "using delegation"],
  [ASSIGNMENT_TYPE.AUTOMATICALLY, "automatically"],
  [ASSIGNMENT_TYPE.MANUALLY, "manually"],
  [ASSIGNMENT_TYPE.SHARES, "automatically by Shares"],
]);

const AssignmentDetails = ({
  actorName,
  actorColor,
  previousUserName,
  previousUserColor,
  newUserName,
  newUserColor,
  assignmentType,
  entityType = "Lead",
}: AssignmentDetailsProps) => {
  const theme = useTheme();

  const showActor =
    assignmentType !== ASSIGNMENT_TYPE.DELEGATION &&
    assignmentType !== ASSIGNMENT_TYPE.AUTO_ASSIGNMENT &&
    assignmentType !== ASSIGNMENT_TYPE.AUTOMATICALLY &&
    assignmentType !== ASSIGNMENT_TYPE.SINGLE_LEAD &&
    assignmentType !== ASSIGNMENT_TYPE.SHARES;
  const getAssignmentText = () => {
    let text = `${entityType} has been assigned `;

    text += assignmentType
      ? `${assignmentTypeToTextMap.get(assignmentType)} `
      : "";

    if (showActor && actorName) {
      text += "by ";
    }

    return text;
  };

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xxs}
      rowGap={theme.nawy.spacing.xxs}
      flexWrap="wrap"
      alignItems="center"
    >
      <ActivityDetailsText>{getAssignmentText()}</ActivityDetailsText>

      {actorName && showActor && (
        <>
          <UserNameTag name={actorName} color={actorColor} />
        </>
      )}

      {previousUserName &&
        previousUserName !== actorName &&
        previousUserName !== newUserName && (
          <>
            <ActivityDetailsText>from</ActivityDetailsText>
            <UserNameTag name={previousUserName} color={previousUserColor} />
          </>
        )}

      {newUserName && (
        <>
          <ActivityDetailsText>to</ActivityDetailsText>
          <UserNameTag name={newUserName} color={newUserColor} />
        </>
      )}
    </Stack>
  );
};

export default AssignmentDetails;
